var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mx-auto"},[_c('CategorySessionPointProgressBar',{attrs:{"totalScore":_vm.categoryTotalPoints,"score":_vm.categoryPoints}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }